<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="5">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="$l('form_label_search')"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
      <b-col style="text-align: end;">
        <b-button
          size="sm"
          class="ml-2"
          v-if="showButton"
          variant="outline-primary"
          @click="$emit('openEditPage', '')"
        >
          <b-icon-plus></b-icon-plus>
          {{ $l("btn_add_item_value") || "添加明细" }}
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// 初始表单
const initForm = { keyword: "" };
export default {
  data() {
    return { form: { ...initForm } };
  },
  props: {
    dfDefinitionCategoryCode: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    showButton() {
      return !this.disabled && this.dfDefinitionCategoryCode;
    },
  },
  mounted() {
    this.query();
  },
  watch: {
    dfDefinitionCategoryCode: {
      handler() {
        this.query();
      },
      deep: true,
    },
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) this.$emit("reset");

      this.$emit("query", {
        ...this.form,
        dfDefinitionCategoryCode: this.dfDefinitionCategoryCode,
      });
    },
    reset() {
      this.form = { ...initForm };
    },
  },
};
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
